import { render, staticRenderFns } from "./RejoinSessionHeader.vue?vue&type=template&id=937b8cac&scoped=true&"
import script from "./RejoinSessionHeader.vue?vue&type=script&lang=js&"
export * from "./RejoinSessionHeader.vue?vue&type=script&lang=js&"
import style0 from "./RejoinSessionHeader.vue?vue&type=style&index=0&id=937b8cac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "937b8cac",
  null
  
)

export default component.exports